import { render, staticRenderFns } from "./ProjectEditDates.vue?vue&type=template&id=e82ae39e&"
import script from "./ProjectEditDates.vue?vue&type=script&lang=js&"
export * from "./ProjectEditDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports